import { type WidgetComponent } from '@wix/chat-widget-common-widgets';
import { type SingleSelectWidgetData } from '@wix/common-widget-types';
import { Box, Image, Text } from '@wix/design-system';
import React, { useEffect } from 'react';
import { ACTIONS } from '../../constants';
import { CardLayout } from '../shared/CardLayout/CardLayout';
import { WidgetButton } from '../shared/WidgetButton/WidgetButton';
import {
  WidgetLayout,
  type ShowMoreConfig,
} from '../shared/WidgetLayout/WidgetLayout';

export interface ShowMore {
  showMore: ShowMoreConfig;
}

export const SingleSelectWidget: WidgetComponent<
  SingleSelectWidgetData & ShowMore
> = ({ data, context }) => {
  useEffect(() => {
    context.onWidgetAction(SINGLE_SELECT_WIDGET, {
      action: ACTIONS.WIDGET_LOAD,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cards = (data.options ?? []).map(
    ({ image, title, button, text, value }) => (
      <CardLayout key={value} theme={context.theme}>
        {image && <Image src={image} borderRadius="4px" />}

        <Box align="space-between" verticalAlign="middle">
          {title && (
            <Text size="tiny" weight="bold" light={context.theme === 'dark'}>
              {title}
            </Text>
          )}

          {button && (
            <WidgetButton
              type="button"
              priority="secondary"
              respondValues={[value]}
              respondText={button.respondText}
              webAction={button.webAction}
              context={context}
              icon={button.icon}
              onClick={() => {
                context.onWidgetAction?.(SINGLE_SELECT_WIDGET, {
                  action: ACTIONS.BUTTON_CLICK,
                  value: button.label,
                });
              }}
            >
              {button.label}
            </WidgetButton>
          )}
        </Box>

        {text && (
          <Text size="tiny" light={context.theme === 'dark'}>
            {text}
          </Text>
        )}
      </CardLayout>
    ),
  );

  return (
    <WidgetLayout
      badge={data.badge}
      text={data.text}
      secondaryButton={data.secondaryButton}
      primaryButton={data.primaryButton}
      context={context}
      respondValues={data.options?.map((option) => option.value) ?? []}
      showMore={data.showMore}
    >
      {cards}
    </WidgetLayout>
  );
};

export const SINGLE_SELECT_WIDGET = 'SINGLE_SELECT_WIDGET';
